import React from 'react';
import styled from 'styled-components';
import { devices } from '../../data/constants';

const GroupContainer = styled.div`
  margin-bottom: 20px;
`;

const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  cursor: ${({ $collapsible }) => $collapsible ? 'pointer' : 'default'};
`;

const GroupTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.cardText};
  display: flex;
  align-items: center;
  gap: 8px;
`;

const GroupSubtitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.subTextColor};
  font-weight: 400;
`;

const GroupContent = styled.div`
  display: ${({ $isOpen }) => $isOpen ? 'flex' : 'none'};
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px;
  background: ${({ theme }) => theme.colors.opacityColor};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.borderColor};

  @media only screen and ${devices.md} {
    flex-direction: column;
    gap: 8px;
  }
`;

const InputGroup = ({ 
  title, 
  subtitle, 
  collapsible = false, 
  defaultOpen = true,
  isOpen,
  onToggle,
  children 
}) => {
  // Use internal state if not controlled
  const [internalOpen, setInternalOpen] = React.useState(defaultOpen);
  const open = isOpen !== undefined ? isOpen : internalOpen;

  const handleToggle = () => {
    if (collapsible) {
      if (onToggle) {
        onToggle();
      } else {
        setInternalOpen(!internalOpen);
      }
    }
  };

  return (
    <GroupContainer>
      <GroupHeader $collapsible={collapsible} onClick={handleToggle}>
        <GroupTitle>
          {title}
          {subtitle && <GroupSubtitle>{subtitle}</GroupSubtitle>}
        </GroupTitle>
      </GroupHeader>
      <GroupContent $isOpen={open}>
        {children}
      </GroupContent>
    </GroupContainer>
  );
};

export default InputGroup;
